import {
  createStore
} from 'vuex'

export default createStore({
  state: {
    timenum: ' 按时发生法发顺丰'
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {}
})